jQuery(document).ready(function () {
  /*jshint loopfunc: true */
  'use strict';

  // // Mobile Menu Toggle Functionality
  // const mobileMenuIcon = document.querySelector('.mobile-nav');
  // const itemsWithChildren = [...document.querySelectorAll('.mobile-menu .menu-item-has-children > a')];

  // const mobileMenuToggle = function () {
  //   mobileMenuIcon.addEventListener('click', function (e) {
  //     e.preventDefault();
  //     document.querySelector('body').classList.toggle('menu-open');
  //   });
  // };

  // const subMenuToggle = function () {
  //   for (let i = 0; i < itemsWithChildren.length; ++i) {
  //     itemsWithChildren[i].addEventListener('click', function (e) {
  //       e.preventDefault();
  //       this.parentElement.classList.toggle('open-panel');
  //     });
  //   }
  // };

  // mobileMenuToggle();
  // subMenuToggle();

  // Animate counter

  function impactNumberAnimation() {
    let a = 0;
    jQuery(window).scroll(function() {
      const oTop = jQuery('.counter-item').offset().top - window.innerHeight;
      if (a == 0 && jQuery(window).scrollTop() > oTop) {
        jQuery('.counter-item .number').each(function() {
          jQuery(this).prop('Counter',0).animate({
              Counter: this.textContent
          }, {
              duration: 3200,
              easing: 'swing',
              step: function (now) {
                  jQuery(this).text(commaSeparateNumber(Math.ceil(now)));
              }
          });
        });
        a = 1;
      }

    });
  }

  function commaSeparateNumber(val){
    while (/(\d+)(\d{3})/.test(val.toString())){
      val = val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    }
    return val;
  }

  if (document.querySelector('.counter-item')) {
    impactNumberAnimation();
  }

  /*
  * Replace all SVG images with inline SVG
  */

  jQuery('img.svg').each(function () {
    const $img = jQuery(this);
    const imgID = $img.attr('id');
    const imgClass = $img.attr('class');
    const imgURL = $img.attr('src');

    jQuery.get(imgURL, function (data) {
      // Get the SVG tag, ignore the rest
      let $svg = jQuery(data).find('svg');

      // Add replaced image's ID to the new SVG
      if (typeof imgID !== 'undefined') {
        $svg = $svg.attr('id', imgID);
      }

      // Add replaced image's classes to the new SVG
      if (typeof imgClass !== 'undefined') {
        $svg = $svg.attr('class', imgClass + ' replaced-svg');
      }

      // Remove any invalid XML tags as per http://validator.w3.org
      $svg = $svg.removeAttr('xmlns:a');

      // Replace image with new SVG
      $img.replaceWith($svg);

    }, 'xml');
  });

  // Scroll to a certain element
  jQuery(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    jQuery('html, body').animate({
      scrollTop: jQuery(jQuery.attr(this, 'href')).offset().top
    }, 500);
  });
});

// Mobile Menu + Search Overlay Triggers

window.onload = function () {
  var searchTrigger = document.querySelector(".search-trigger a");
  var mobileMenuTrigger = document.querySelector(".mobile-menu-trigger");

  if (mobileMenuTrigger) {
    mobileMenuTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      this.classList.toggle('active');
      this.nextElementSibling.classList.toggle('open');
      document.querySelector(".menu-blackout").classList.toggle('active');
    });
  } else {
    console.log("Mobile trigger not found.");
  }

  var searchOverlay = document.querySelector("#search-overlay");
  var searchInput = searchOverlay.querySelector("input#s");

  if (searchTrigger) {
    searchTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      this.classList.toggle('active');
      document.querySelector("#search-overlay").classList.toggle('open');
      document.querySelector(".overlay-content").classList.toggle('active');
      searchInput.focus();
    })
  }

  var closeTrigger = document.querySelector("#close .icon");

  if (closeTrigger) {
    closeTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      searchTrigger.classList.toggle('active');
      document.querySelector("#search-overlay").classList.toggle('open');
      document.querySelector(".overlay-content").classList.toggle('active');
    });
  }

  document.onkeydown = function (e) {
    e = e || window.event;
    var isEscape = false;
    if ("key" in e) {
      isEscape = (e.key == "Escape" || e.key == "Esc");
    } else {
      isEscape = (e.keyCode == 27);
    }
    if (isEscape) {
      e.preventDefault();
      searchTrigger.classList.remove('active');
      document.querySelector("#search-overlay").classList.remove('open');
      document.querySelector(".overlay-content").classList.remove('active');
    }
  };
};
